// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19bvv47k{padding-left:var(--ds-space-250,20px)}\n._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._1ul91lit{min-width:10pc}\n._ca0qv47k{padding-top:var(--ds-space-250,20px)}\n._n3tdv47k{padding-bottom:var(--ds-space-250,20px)}\n._u5f3v47k{padding-right:var(--ds-space-250,20px)}", ""]);
// Exports
module.exports = exports;
